export enum StorageKeysEnum {
  AccessToken = 'APP_ACCESS_TOKEN'
}